import React from 'react'
// components
import Tooltip from '@mui/material/Tooltip'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableSortLabel from '@mui/material/TableSortLabel'

export type THeader = { id: string; label?: string; sortable?: boolean; left?: boolean }

interface TableHeaderProps {
  order: 'asc' | 'desc'
  orderBy: string
  headers: THeader[]
  handleSortChange: (id: string) => void
}

const TableHeader: React.FC<TableHeaderProps> = ({ headers, handleSortChange, order, orderBy }) => {
  return (
    <TableHead>
      <TableRow>
        {headers.map(({ id, label, sortable = false, left = false }) => (
          <TableCell key={id} sortDirection={orderBy === id && (order as any)}>
            {sortable ? (
              <Tooltip
                title={`Click here to sort by ${label}`}
                placement={left ? 'bottom-start' : 'bottom-end'}
                enterDelay={300}>
                <TableSortLabel active={orderBy === id} direction={order} onClick={() => handleSortChange(id)}>
                  {label}
                </TableSortLabel>
              </Tooltip>
            ) : (
              label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

export default TableHeader
